import React from 'react'

import EmailSettings from '@/pages/Settings/EmailSettings'
import PasswordSettings from '@/pages/Settings/PasswordSettings'
import OmniAuthSettings from '@/pages/Settings/OmniAuthSettings'
import DeleteAccount from '@/pages/Settings/DeleteAccount'
import PreferencesSection from '@/pages/Settings/NotificationPreferences'
import UsernameSettings from '@/pages/Settings/UsernameSettings'
import BillingLink from '@/pages/Settings/BillingLink'

const SettingsIndex = () => {
  return (
    <div className='mt-3'>
      <div className="md:grid md:grid-cols-3 md:gap-6">
        <UsernameSettings />
        <div className="col-span-4 mt-3" />
        <BillingLink />
        <div className="col-span-4 mt-3" />
        <PreferencesSection />
        <div className="col-span-4 mt-3" />
        <EmailSettings />
        <div className="col-span-4 mt-3" />
        <PasswordSettings />
        <div className="col-span-4 mt-3" />
        <OmniAuthSettings />
        <div className="col-span-4 mt-3" />
        <DeleteAccount />
      </div>
    </div>
  )
}

export default SettingsIndex
